import moment from 'moment';

const dateFilter = (value) => moment(value, '', 'ru').format('DD MMMM YYYY');
export default dateFilter;
